/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_All_Applied_A_To_BInputs */



/**
* | output |
* | --- |
* | "All changes applied from Group A to Group B" |
*
* @param {Compare_Event_Groups_All_Applied_A_To_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_all_applied_a_to_b = /** @type {((inputs?: Compare_Event_Groups_All_Applied_A_To_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_All_Applied_A_To_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les modifications s'appliquent du groupe A au groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Änderungen wurden von Gruppe A auf Gruppe B übertragen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutte le modifiche sono state applicate dal Gruppo A al Gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все изменения внесены из группы А в группу В.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los cambios se aplicaron del Grupo A al Grupo B.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有变更均已从A组变更至B组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべての変更はグループAからグループBに適用されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह A से समूह B में सभी परिवर्तन लागू किए गए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Todas as alterações foram aplicadas do Grupo A para o Grupo B.")
	return /** @type {LocalizedString} */ ("All changes applied from Group A to Group B")
});